import type { StylesConfig } from 'react-select';

/** Shared react-select styles for the pass builder pages. */
export const passBuilderSelectStyles: StylesConfig = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#EEEEEE',
    borderRadius: '5px',
    border: 'none',
    boxShadow: 'none',
    minHeight: '35px',
    cursor: 'pointer',
    ':hover': { border: 'none' },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#989898',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#4C4C4C',
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#4C4C4C',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#EEEEEE' : 'white',
    color: '#4C4C4C',
    fontSize: '14px',
    cursor: 'pointer',
    ':hover': { backgroundColor: '#F8F8F8' },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '5px',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#989898',
    padding: '0 8px',
    ':hover': { color: '#4C4C4C' },
  }),
};
